import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

const buttonPlay = document.getElementById("button-play");
const tvVideo = document.getElementById("tv-video");
const header = document.getElementById("header");
const mobMenuBtn = document.getElementById("mobile-menu-btn");
const offCanvasMenu = document.querySelector(".main-menu");
const actionButton = document.querySelector("button.btn");
const parallaxCircles = document.querySelectorAll(".circle--animated");
const underlines = document.querySelectorAll(".title-underline");
const stickyElements = document.querySelectorAll(".sticky-animation");
const sections = document.getElementsByTagName("section");
const mobileMaxWidth = 769;
const mobileMaxHeight = 400;
const overlay = document.querySelector(".overlay");

function preventLandscapeView() {
    window.innerHeight <= mobileMaxHeight
        ? (overlay.className = "overlay")
        : (overlay.className = "overlay hide");
};

function setCustomVh() {
    let vh = window.innerHeight * 0.01;
    // Set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};

function setBodyHeight() {
    let sectionsHeight = 0;

    [...sections].forEach( (section, index, array) => {
        section.setAttribute('y-distance', `${sectionsHeight.toFixed(2)}`);
        section.style.zIndex = (array.length - index);
        sectionsHeight += section.getBoundingClientRect().height;
    });

    document.body.style.height = `${sectionsHeight}px`;
};

let isVideoPlayed = false;

function controlVideo({ video = tvVideo }) {
    isVideoPlayed ? video.pause() : video.play();
    isVideoPlayed = !isVideoPlayed;
    this.classList.toggle('hidden');
}

buttonPlay.addEventListener("click", controlVideo);

function toggleMenuState() {
    mobMenuBtn.classList.toggle("opened");
    document.body.classList.toggle("scrolling-disabled");
    header.classList.toggle("fixed");
}

mobMenuBtn.addEventListener("click", toggleMenuState);

offCanvasMenu.addEventListener("click", ({target}) => {
    window.innerWidth < mobileMaxWidth ? toggleMenuState() : "";
    if (target.href) {
        let element = document.querySelector(target.getAttribute('href'));
        element ? window.scrollTo({top:element.getAttribute('y-distance'), behavior: "smooth"}) : "";
    }
    event.preventDefault();
});

actionButton.addEventListener("click", function() {
    let element = document.querySelector(this.getAttribute('href'));
    element ? window.scrollTo({top: element.getAttribute('y-distance'), behavior: "smooth"}) : "";
});

window.addEventListener("scroll", () => {
    animateCircles();
    underlineEffects();
    stickyEffect();
    pageScrollOverlap();
});

function animateCircles() {
    parallaxCircles.forEach(circle => {
        if (isVisible(circle)) {
            let sectionOffset = centerSection.getAttribute('y-distance');
            let transformValue = [
                `scale(${1 + (pageYOffset-sectionOffset) / 300})`,
                `translateY(-${(pageYOffset-sectionOffset) / 7}px)`
            ].join(' ');

            circle.style.transform = transformValue;
        }
    })
};

function underlineEffects() {
    underlines.forEach(element => {
        let underlineBottomPosition = element.getBoundingClientRect().bottom;
        let transformUnderline = `translateX(${-underlineBottomPosition /
            3}px)`;
        element.style.transform = transformUnderline;

        let title = element.closest(".title");
        let titleBottomPosition = title.getBoundingClientRect().bottom;
        let transformTitle = `translateX(${titleBottomPosition / 5}px)`;
        title.style.transform = transformTitle;
    })
};

function stickyEffect() {
    stickyElements.forEach(element => {
        if (isVisible(element)) {
            let sectionOffset = centerSection.getAttribute('y-distance');
            let parent = element.parentElement;
            let parentRect = parent.getBoundingClientRect();
            let elementRect = element.getBoundingClientRect();

            if (parentRect.top <= 0 && parentRect.height >= elementRect.height-parentRect.top) {
                element.style.transform = `translateY(${-parentRect.top}px)`;
            }
        }
    })
};

let lastScrollTop = 0;
let centerSectionIndex = 0;
let centerSection = [...sections][centerSectionIndex];
let prevSection;
let offset = 0;

function pageScrollOverlap() {

    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop) {
        if (centerSection.getBoundingClientRect().bottom <= 0) {
            prevSection = centerSection;
            prevSection.style.top = `-${
                prevSection.getBoundingClientRect().height
            }px`;
            prevSection.style.transform = "translateY(0px)";
            offset += prevSection.getBoundingClientRect().height;
            centerSectionIndex += 1;
            centerSection = [...sections][centerSectionIndex];
        }

    } else {

        if ( centerSection.getBoundingClientRect().top >= 0 && centerSectionIndex > 0) {
            centerSection = prevSection;
            centerSection.style.top = '0';
            centerSection.style.transform = `${centerSection.getBoundingClientRect().height}px`;
            offset -= prevSection.getBoundingClientRect().height;
            centerSectionIndex -= 1;
            prevSection = [...sections][centerSectionIndex-1];
        }
    }
    let translateValue = pageYOffset - offset;
    centerSection.style.transform = `translateY(-${translateValue < 0 ? 0 : translateValue}px)`;

    lastScrollTop = st <= 0 ? 0 : st;

};

function isVisible(element) {
    if (centerSection.contains(element)) {
        return true;
    }
};

window.addEventListener("resize", () => {
    preventLandscapeView();
    setBodyHeight();
});

window.addEventListener('DOMContentLoaded', () => {
    setCustomVh();
    preventLandscapeView();
    setTimeout(setBodyHeight, 500)
});
